import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/ui/layout/global.json'

export const LAYOUT_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
